import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-background-800 text-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-rocket-2-fill text-lg"></i>
              </span>
              <span className="font-heading text-xl text-background-50">动漫网</span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              一个专注动漫导航与资讯的门户站，聚合全频道分类与新番推荐。收藏一次，随时访问，带你轻松玩转动漫世界。
            </p>
            <div className="mt-5 flex gap-2">
              {["ri-wechat-fill", "ri-weibo-fill", "ri-bilibili-fill", "ri-qq-fill"].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  aria-label="社交平台"
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-background-700 text-background-200 transition hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={`${icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">频道分类</h4>
            <ul className="mt-4 space-y-2.5">
              {categories.slice(0, 6).map((c) => (
                <li key={c.slug}>
                  <Link to={`/category/${c.slug}`} className="text-sm text-background-300 transition hover:text-primary-400">
                    {c.name}动漫
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">快速导航</h4>
            <ul className="mt-4 space-y-2.5">
              <li><Link to="/" className="text-sm text-background-300 transition hover:text-primary-400">动漫网首页</Link></li>
              <li><Link to="/category" className="text-sm text-background-300 transition hover:text-primary-400">分类频道</Link></li>
              <li><Link to="/article" className="text-sm text-background-300 transition hover:text-primary-400">动漫资讯</Link></li>
              <li><Link to="/about" className="text-sm text-background-300 transition hover:text-primary-400">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">联系方式</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-background-300">
              <li className="flex items-center gap-2"><i className="ri-mail-line text-primary-400"></i>service@dongmanwang.com</li>
              <li className="flex items-center gap-2"><i className="ri-phone-line text-primary-400"></i>400-888-6666</li>
              <li className="flex items-center gap-2"><i className="ri-map-pin-line text-primary-400"></i>中国 · 上海市动漫产业园区</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-700">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-5 sm:flex-row md:px-6">
          <p className="text-xs text-background-400">© 2026 动漫网 dongmanwang.com 版权所有 · 动漫网官网首页与导航页入口</p>
          <div className="flex items-center gap-4 text-xs text-background-400">
            <a href="#" rel="nofollow" className="transition hover:text-background-100">隐私政策</a>
            <a href="#" rel="nofollow" className="transition hover:text-background-100">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}